/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiaUserPermissions } from '../interfaces/sia-user-permissions';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SiaUsersApi {
  private http = inject(SiaHttpService);

  private readonly apiController: string = 'users';
  private readonly authController: string = 'authentications';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  getCurrent(): Promise<any> {
    return this.http.get(`${this.apiController}/current`);
  }

  updateLanguage(language: string) {
    return this.http.get(`${this.apiController}/set-language/${language}`);
  }

  getEnableLanguages() {
    return this.http.get(`${this.apiController}/get-enable-languages`);
  }
  delete(id: number): Promise<boolean> {
    return this.http.delete(`${this.apiController}/${id}`);
  }

  inviteUser(id: string): any {
    let params = new HttpParams();
    params = params.set('userId', `${id}`);
    return this.http.get(`${this.authController}/invite-user`, { params });
  }

  impersonate(userId: number) {
    return this.http.post(`${this.apiController}/impersonate`, { id: userId });
  }

  geSiaUserPermissions(componentId: string): Promise<SiaUserPermissions> {
    let params = new HttpParams();
    params = params.set('componentId', `${componentId}`);
    return this.http.get(`${this.apiController}/component-permissions`, {
      params,
    });
  }

  getAvatar(uid: number) {
    let params = new HttpParams();
    params = params.set('avatarId', `${uid}`);
    let controller = `${this.apiController}/avatar`;
    return this.http.execDownload(controller, params);
  }

  getUsersInGroups(groups: number[]) {
    return this.http.post(`${this.apiController}/users-in-groups`, groups);
  }

  createGroup(groupId: string) {
    return this.http.post(
      `${this.apiController}/profile/group?groupId=${groupId}`,
      null,
    );
  }
  heartbeat() {
    return this.http.post(`authentications/heart-beat`, {});
  }
}
